module.exports = "<div class=\"container-grid my-4 height height-100-vh\">\r\n  <ag-grid-angular\r\n    [gridOptions]=\"grid\"\r\n  >\r\n  </ag-grid-angular>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/service-provider/components/history-service-provider/history-service-provider.component.html
// module id = 2531
// module chunks = 66